import { useEffect, useState } from "react";
import { ExampleSentence } from ".";
import * as consts from "../../../../../common/consts";
import { BLOB_URL, Z_APPS_TOP_URL } from "../../../../../common/consts";
import { sFetchJson } from "../../../../../common/util/sFetchJson";
import { Sentence, Word } from "../../../../../types/stories";
import { ATargetBlank } from "../../../Link/ATargetBlank";

export function FolktaleExample({
    storyName,
    lineNumber,
    boldInfo,
}: {
    storyName: string;
    lineNumber: number;
    boldInfo: string;
}) {
    const [s, setSentence] = useState<Sentence>({
        storyId: 0,
        lineNumber: 0,
        kanji: "Loading...",
        hiragana: "Loading...",
        romaji: "Loading...",
        english: "Loading...",
    });
    const [words, setWords] = useState<Word[]>([
        {
            lineNumber: 0,
            wordNumber: 0,
            kanji: "loading...",
            hiragana: "loading...",
            english: "loading...",
        },
    ]);

    useEffect(() => {
        const fetchSentence = async () => {
            const url = `api/Stories/GetOneSentence/${storyName}/${lineNumber}`;
            const { sentence, words } = await sFetchJson<{
                sentence: Sentence;
                words: Word[];
            }>(url);
            setSentence(sentence);
            setWords(words);
        };
        storyName && lineNumber && fetchSentence();
    }, [storyName, lineNumber]);

    const audioFolder = storyName?.split("--")[0];
    const id = `${storyName}-${s.lineNumber}`;
    const folktaleTitle = storyName
        .split("--")
        .join(" - ")
        .split("_")
        .join(" ");

    return (
        <div
            id={id}
            key={id}
            style={{ marginBottom: 25, textShadow: "initial" }}
        >
            <img
                src={`${consts.BLOB_URL}/folktalesImg/${
                    storyName.split("--")[0]
                }.png`}
                alt={folktaleTitle}
                title={folktaleTitle}
                className="renderedImg"
            />
            <div style={{ fontWeight: "bold", marginBottom: 20 }}>
                {"Below is a sentence from the folktale "}
                <ATargetBlank href={`${Z_APPS_TOP_URL}/folktales/${storyName}`}>
                    {`${folktaleTitle}>>`}
                </ATargetBlank>
            </div>
            <ExampleSentence
                s={s}
                boldInfo={boldInfo}
                words={words}
                audioPath={`${BLOB_URL}/folktalesAudio/${audioFolder}/folktale-audio${s.lineNumber}.m4a`}
            />
        </div>
    );
}
